export interface AuditEntry {
  id: string;
  actorType: string;
  actorEmail: string | null;
  action: string;
  entity: string;
  entityId: string | null;
  diff: unknown;
  at: string;
}

export interface AuditResponse {
  entries: AuditEntry[];
  nextCursor: string | null;
}

export interface AuditFacets {
  actions: string[];
  entities: string[];
  actors: string[];
}

export const PAGE_SIZE = 50;
export const ALL = '__all__';
